module.exports = __webpack_public_path__ + "img/logo.7f5dc91b.png";